import React, { Component } from 'react';
import { Field } from 'redux-form';
import { ButtonToolbar } from 'react-bootstrap';
import RenderDate from './renderDateField_newAirDetail';
import '../../css/booking.css';
import 'font-awesome/css/font-awesome.min.css';

export default class BookingAirDetailNew extends Component {
  renderField(field) {
    const {
      label,
      type,
      input,
      meta: { touched, error }
    } = field;
    return (
      <div className="form-group form-group-sm col-sm-6">
        <div className="row">
          <label className="col-sm-4 col-form-label">{label}</label>
          <div className="col-sm-8">
            <input className="form-control" type={type} {...input} />
            <div className="text-danger">{touched ? error : ''}</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      fields,
      meta: { error, submitFailed }
    } = this.props;
    return (
      <ul>
        <li>
          <div className="row add-detail-margin">
            <button type="button" className="add-detail btn btn-primary btn-sm" onClick={() => fields.push({})}>
              Add Detail
            </button>
            {submitFailed && error && <span>{error}</span>}
          </div>
        </li>
        {fields.map((detail, index) => (
          <li key={index}>
            <fieldset className="for-panel">
              <legend>Detail #{index + 1}</legend>
              <div className="row">
                <div className="col-sm-6" />
                <div className="col-sm-6">
                  <ButtonToolbar className="pull-right add-detail-margin">
                    <button type="button" className="btn btn-danger" onClick={() => fields.remove(index)}>
                      <i className="fa fa-trash-o" aria-hidden="true" />
                    </button>
                  </ButtonToolbar>
                </div>
              </div>
              <div className="row">
                <Field name={`${detail}.PONo`} type="text" component={this.renderField} label="PO #:" />
                <Field name={`${detail}.ShipperName`} type="text" component={this.renderField} label="Shipper Name:" />
              </div>
              <div className="row">
                <Field name={`${detail}.HAWB`} type="text" component={this.renderField} label="HAWB:" />
                <Field name={`${detail}.csnPO`} type="text" component={this.renderField} label="Customer PO:" />
              </div>
              <div className="row">
                <Field
                  name={`${detail}.CargoDescription`}
                  type="text"
                  component={this.renderField}
                  label="Description:"
                />
                <Field name={`${detail}.DelrAddr`} type="text" component={this.renderField} label="Delr. Addr.:" />
              </div>
              <div className="row">
                <Field name={`${detail}.HTSNo`} type="text" component={this.renderField} label="HTS #:" />
                <Field name={`${detail}.FinalDueDate`} type="text" component={RenderDate} label="Final Due Date:" />
              </div>
              <div className="row">
                <Field name={`${detail}.CargoReadyDate`} type="text" component={RenderDate} label="Cargo Ready Date:" />
                <Field name={`${detail}.CargoRapDate`} type="text" component={RenderDate} label="Cargo Rap Date:" />
              </div>
              <div className="row">
                <Field name={`${detail}.EstDelivery`} type="text" component={RenderDate} label="Estimate Delr. Date:" />
                <Field name={`${detail}.CargoVol`} type="text" component={this.renderField} label="Cargo Vol:" />
              </div>
              <div className="row">
                <Field name={`${detail}.GrossWeight`} type="text" component={this.renderField} label="Gross Wt:" />
                <Field
                  name={`${detail}.ChargeableWeight`}
                  type="text"
                  component={this.renderField}
                  label="Chargeable Wt:"
                />
              </div>
              <div className="row">
                <Field name={`${detail}.CartonQty`} type="text" component={this.renderField} label="QTY.[cartons]:" />
                <Field name={`${detail}.PalletQty`} type="text" component={this.renderField} label="QTY. [pallets]:" />
              </div>
            </fieldset>
          </li>
        ))}
      </ul>
    );
  }
}
